import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link2, ShieldCheck } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Logo } from "../components/Logo";
import { Spinner } from "../components/ui-kit";

export default function DirectAccess() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  const { reload } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setError("Link di accesso non valido"); return; }
    api.post("/auth/direct-access", { token }).then(async () => {
      await reload();
      navigate("/app", { replace: true });
    }).catch((requestError) => setError(formatApiErrorDetail(requestError.response?.data?.detail) || "Link non valido o scaduto"));
  }, [navigate, params, reload]);

  return <div className="min-h-screen grid place-items-center bg-navy p-6"><div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-card"><div className="mb-6 flex justify-center"><Logo size="md" /></div>{error ? <><div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-red-50 text-red-600"><Link2 className="h-6 w-6" /></div><h1 className="font-heading text-2xl font-semibold text-navy">Accesso non disponibile</h1><p className="mt-2 text-sm text-slate-500">{error}. Richiedi al consulente un nuovo link temporaneo.</p></> : <><div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-emerald-50 text-emerald-600"><ShieldCheck className="h-6 w-6" /></div><h1 className="font-heading text-2xl font-semibold text-navy">Accesso sicuro in corso</h1><p className="mt-2 text-sm text-slate-500">Verifica del link temporaneo…</p><div className="mt-5 flex justify-center"><Spinner /></div></>}</div></div>;
}
